export default __webpack_public_path__ + "static/media/soda.ff3874f5.svg";